import { GxSwitch } from '@garpix/garpix-web-components-react';
import React, { FC } from 'react';
import styles from './styles/index.module.scss'

interface ISwitcher {
    'checked'?: boolean;
    'disabled'?: boolean;
    'invalid'?: boolean;
    'name'?: string;
    'onGx-blur'?: (event: CustomEvent<any>) => void;
    'onGx-change'?: (event: CustomEvent<any>) => void;
    'onGx-focus'?: (event: CustomEvent<any>) => void;
    'required'?: boolean;
    'value'?: string;
    label?: string,
    'className'?: string
}

const Switcher: FC<ISwitcher> = ({ children, label,className, ...props }) => {
    return (
        <div className={className}>
            {label && <span className={styles['switcher--label']}>{label}</span>}
            <GxSwitch className={styles['switcher']} {...props}>
                {children}
            </GxSwitch>
        </div>
    )
}

export default Switcher;